const state = {
  correctionReasonEnum: [],
  auditSectionKeyEnum: [],
  auditReasonEnum: [],
  auditDetailsStatusEnum: []
}

const getters = {
  getCorrectionReasonEnum: (state) => state.correctionReasonEnum,
  getAuditSectionKeyEnum: (state) => state.auditSectionKeyEnum,
  getAuditReasonEnum: (state) => state.auditReasonEnum,
  getAuditDetailsStatusEnum: (state) => state.auditDetailsStatusEnum
}

const actions = {}

const mutations = {
  setCorrectionReasonEnum (state, data) {
    state.correctionReasonEnum = data
  },
  setAuditSectionKeyEnum (state, data) {
    state.auditSectionKeyEnum = data
  },
  setAuditReasonEnum (state, data) {
    state.auditReasonEnum = data
  },
  setAuditDetailsStatusEnum (state, data) {
    state.auditDetailsStatusEnum = data
  }
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations
}
